import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@mui/material";
import { PiGameControllerDuotone } from "react-icons/pi";
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { createClickEngagementRecorder } from "../../utils/api";
import { useLocation } from 'react-router-dom';

const SmallAppsButton = () => {
  const location_route = useLocation();
  const { t } = useTranslation();
  const { push, location } = useRouter();
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const handleBtnClick = () => {
    clickRecorder("smallApps");
    push({
      pathname: `${ROUTES.SMALL_APPS_PAGE}`,
    }, location_route.search);
  };

  const isActive =
    location.pathname.includes(ROUTES.SMALL_APPS_PAGE);

  return (
    <Tooltip
      title={t("Menu_Game_Center")}
      placement="bottom"
      arrow
      disableInteractive
    >
      <IconButton
        aria-label="invite"
        onClick={handleBtnClick}
        sx={{ padding: "5px", color: isActive ? "#3396FF" : "#FFFFFF" }}
      >
        <PiGameControllerDuotone style={{ fontSize: "20px" }} />
      </IconButton>
    </Tooltip>
  );
};

export default SmallAppsButton;
